<main class="archetype-editor" [class.archetype-editor--inspector-open]="selectedNode()">
  @if (isNew) {
    <section class="create-shell">
      <button appButton variant="ghost" size="sm" type="button" (click)="back()">
        <ng-icon name="heroArrowLeft" size="16" aria-hidden="true" />
        Arquétipos
      </button>
      <div appUiPanelCard class="create-panel">
        <div class="create-panel__copy">
          <span class="create-panel__index">Novo fluxo</span>
          <h1>Comece pelo propósito, não pela complexidade.</h1>
          <p>Você receberá um fluxo seguro e funcional para refinar no canvas.</p>
        </div>
        <div class="create-panel__form">
          <label>
            <span appUiLabel>Nome</span>
            <input appInput type="text" placeholder="Ex.: Qualificação comercial" [value]="createName()" (input)="createName.set($any($event.target).value)" />
          </label>
          <label>
            <span appUiLabel>Descrição</span>
            <textarea appTextarea rows="4" placeholder="Quando este arquétipo deve ser usado?" [value]="createDescription()" (input)="createDescription.set($any($event.target).value)"></textarea>
          </label>
          <div class="create-panel__actions">
            <button appButton variant="primary" type="button" [disabled]="busyAction() === 'create'" (click)="create()">
              @if (busyAction() === 'create') { <app-ui-spinner [size]="16" [stroke]="2" /> }
              Criar e abrir editor
            </button>
          </div>
        </div>
      </div>
    </section>
  } @else if (loading()) {
    <section class="editor-loading"><app-ui-spinner [size]="34" /><span>Preparando editor</span></section>
  } @else {
    <header class="editor-toolbar">
      <button appUiIconButton variant="ghost" size="sm" type="button" aria-label="Voltar para arquétipos" (click)="back()">
        <ng-icon name="heroArrowLeft" size="17" aria-hidden="true" />
      </button>

      <div class="editor-toolbar__identity">
        @if (readOnly()) {
          <strong>{{ name() }}</strong>
        } @else {
          <input class="editor-name" type="text" aria-label="Nome do arquétipo" [value]="name()" (input)="updateName($event)" />
        }
        <span>{{ statusText() }}</span>
      </div>

      <div class="editor-toolbar__status">
        @if (archetype()?.origin === 'system') {
          <span appBadge tone="neutral" size="xs"><ng-icon name="heroLockClosed" size="12" /> Template do sistema</span>
        } @else if (version()?.validationStatus === 'valid') {
          <span appBadge tone="success" size="xs"><ng-icon name="heroCheckCircle" size="12" /> Validado</span>
        } @else if (issues().length) {
          <span appBadge tone="danger" size="xs"><ng-icon name="heroExclamationTriangle" size="12" /> {{ issues().length }} pendência(s)</span>
        }
      </div>

      <div class="editor-toolbar__actions">
        @if (archetype()?.origin === 'system') {
          <button appButton variant="primary" size="sm" type="button" [disabled]="busyAction() === 'duplicate'" (click)="duplicate()">
            <ng-icon name="heroDocumentDuplicate" size="15" aria-hidden="true" />
            Duplicar template
          </button>
        } @else if (!version() || version()?.status !== 'draft') {
          <button appButton variant="primary" size="sm" type="button" [disabled]="busyAction() === 'draft'" (click)="createDraft()">
            <ng-icon name="heroPlus" size="15" aria-hidden="true" />
            Nova versão
          </button>
        } @else {
          <button appButton variant="secondary" size="sm" type="button" (click)="libraryOpen.set(true)">
            <ng-icon name="heroPlus" size="15" aria-hidden="true" />
            Node
          </button>
          <button appButton variant="ghost" size="sm" type="button" [disabled]="busyAction() !== null || hasJsonErrors()" (click)="validate()">
            <ng-icon name="heroDocumentCheck" size="15" aria-hidden="true" />
            Validar
          </button>
          <button appButton variant="ghost" size="sm" type="button" [disabled]="busyAction() !== null || hasJsonErrors()" (click)="testOpen.set(true)">
            <ng-icon name="heroBeaker" size="15" aria-hidden="true" />
            Testar
          </button>
          <button appButton variant="secondary" size="sm" type="button" [disabled]="busyAction() !== null || !dirty() || hasJsonErrors()" (click)="save()">
            @if (busyAction() === 'save') { <app-ui-spinner [size]="14" [stroke]="2" /> }
            Salvar
          </button>
          <button appButton variant="primary" size="sm" type="button" [disabled]="busyAction() !== null || !canPublish()" (click)="publish()">
            Publicar
          </button>
        }
      </div>
    </header>

    <section class="canvas-area" aria-label="Fluxo do arquétipo">
      @if (!version()) {
        <div class="no-version">
          <h2>Este arquétipo ainda não tem uma versão.</h2>
          <p>Crie um rascunho para configurar o fluxo.</p>
        </div>
      } @else {
        <f-flow
          fDraggable
          class="archetype-flow"
          fFlowId="archetype-editor-flow"
          (fCreateConnection)="createConnection($event)"
        >
          <f-background>
            <f-rect-pattern id="archetype-grid" [hColor]="'var(--color-line)'" [vColor]="'var(--color-line)'" [hSize]="30" [vSize]="30" />
          </f-background>

          <f-canvas [position]="canvasPosition" [scale]="canvasScale">
            <f-connection-for-create
              [fType]="connectionType"
              [fBehavior]="connectionBehavior"
              [fInputSide]="inputSide"
              [fOutputSide]="outputSide"
            >
              <f-connection-marker-arrow [type]="markerEnd" />
            </f-connection-for-create>

            @for (edge of edges(); track edge.id) {
              <f-connection
                [fConnectionId]="edge.id"
                [fOutputId]="edgeOutputId(edge)"
                [fInputId]="edgeInputId(edge)"
                [fType]="connectionType"
                [fBehavior]="connectionBehavior"
                [fInputSide]="inputSide"
                [fOutputSide]="outputSide"
              >
                <f-connection-marker-arrow [type]="markerEnd" />
              </f-connection>
            }

            @for (node of nodes(); track node.id) {
              <article
                appUiPanelCard
                fNode
                fDragHandle
                [fNodeId]="node.id"
                [fNodePosition]="node.position"
                (fNodePositionChange)="moveNode(node.id, $event)"
                class="archetype-node"
                [ngClass]="{
                  'archetype-node--selected': selectedNodeId() === node.id,
                  'archetype-node--protected': node.protected,
                  'archetype-node--invalid': issueForNode(node.id)
                }"
                tabindex="0"
                [attr.aria-label]="nodeTypeLabel(node.type) + ': ' + node.name"
                [attr.aria-selected]="selectedNodeId() === node.id"
                (click)="selectNode(node.id)"
                (keydown.enter)="selectNode(node.id)"
              >
                @if (node.type !== 'start') {
                  <span fNodeInput class="node-port node-port--input" [fInputId]="inputId(node)" [fInputConnectableSide]="inputSide" aria-hidden="true"></span>
                }

                <span class="archetype-node__icon"><ng-icon [name]="nodeIcon(node.type)" size="17" aria-hidden="true" /></span>
                <span class="archetype-node__copy">
                  <small>{{ nodeTypeLabel(node.type) }}</small>
                  <strong>{{ node.name }}</strong>
                </span>
                @if (node.protected) { <ng-icon class="archetype-node__lock" name="heroLockClosed" size="13" aria-label="Node protegido" /> }

                @if (node.type === 'condition') {
                  <span class="condition-ports" aria-hidden="true">
                    <span fNodeOutput class="node-port node-port--true" [fOutputId]="outputId(node, 'true')" [fOutputConnectableSide]="outputSide">Sim</span>
                    <span fNodeOutput class="node-port node-port--false" [fOutputId]="outputId(node, 'false')" [fOutputConnectableSide]="outputSide">Não</span>
                  </span>
                } @else if (node.type !== 'end') {
                  <span fNodeOutput class="node-port node-port--output" [fOutputId]="outputId(node)" [fOutputConnectableSide]="outputSide" aria-hidden="true"></span>
                }
              </article>
            }
          </f-canvas>
        </f-flow>

        <ol class="mobile-flow" aria-label="Fluxo ordenado">
          @for (node of orderedNodes(); track node.id; let index = $index) {
            <li>
              <button type="button" [class.mobile-flow__node--selected]="selectedNodeId() === node.id" (click)="selectNode(node.id)">
                <span>{{ index + 1 }}</span>
                <ng-icon [name]="nodeIcon(node.type)" size="17" aria-hidden="true" />
                <span><small>{{ nodeTypeLabel(node.type) }}</small><strong>{{ node.name }}</strong></span>
                <ng-icon name="heroChevronRight" size="15" aria-hidden="true" />
              </button>
            </li>
          }
        </ol>
      }

      @if (issues().length) {
        <aside class="issue-strip" aria-live="polite">
          <ng-icon name="heroExclamationTriangle" size="16" aria-hidden="true" />
          <span><strong>{{ issues().length }} pendência(s)</strong>{{ issues()[0]?.message }}</span>
          @if (issues()[0]?.nodeId) {
            <button appButton variant="ghost" size="sm" type="button" (click)="selectNode(issues()[0]!.nodeId!)">Revisar</button>
          }
        </aside>
      }
    </section>

    @if (selectedNode(); as node) {
      <aside appUiDrawer class="node-inspector" aria-label="Configuração do node">
        <header appUiDrawerHeader>
          <div class="inspector-heading">
            <span><ng-icon [name]="nodeIcon(node.type)" size="17" /></span>
            <div><small>{{ nodeTypeLabel(node.type) }}</small><strong>{{ node.name }}</strong></div>
          </div>
          <button appUiIconButton variant="ghost" size="sm" type="button" aria-label="Fechar inspector" (click)="closeInspector()">
            <ng-icon name="heroXMark" size="17" />
          </button>
        </header>

        <div appUiDrawerBody class="inspector-body">
          @if (node.protected) {
            <div class="protected-note"><ng-icon name="heroShieldCheck" size="16" /><span>Contrato e posição lógica protegidos. Instruções complementares continuam editáveis.</span></div>
          }

          <label>
            <span appUiLabel>Nome do node</span>
            <input appInput type="text" [disabled]="readOnly()" [value]="node.name" (input)="updateNodeName($event)" />
          </label>

          @if (node.type === 'llm' || node.type === 'response') {
            <label>
              <span appUiLabel>Prompt</span>
              <textarea appTextarea rows="8" [disabled]="readOnly()" [value]="configText(node, 'prompt')" (input)="updateConfig('prompt', $event)"></textarea>
              <span appUiHint>Esta instrução compõe o baseline de segurança; não o substitui.</span>
            </label>
            <div class="inspector-grid">
              <label class="inspector-grid__wide">
                <span appUiLabel>Modelo aprovado</span>
                <select appNativeSelect [disabled]="readOnly()" [value]="modelPolicyValue(node, 'model')" (change)="updateModel($event)">
                  @for (model of models(); track model.id) {
                    <option [value]="model.modelKey">{{ model.displayName }} · {{ model.costTier }}</option>
                  }
                </select>
              </label>
              <label>
                <span appUiLabel>Temperatura</span>
                <input appInput type="number" min="0" max="2" step="0.1" [disabled]="readOnly()" [value]="modelPolicyValue(node, 'temperature')" (input)="updateModelPolicyNumber('temperature', $event)" />
              </label>
              <label>
                <span appUiLabel>Limite de tokens</span>
                <input appInput type="number" min="64" step="64" [disabled]="readOnly()" [value]="modelPolicyValue(node, 'maxTokens')" (input)="updateModelPolicyNumber('maxTokens', $event)" />
              </label>
            </div>
            @if (node.type === 'llm') {
              <div class="switch-row">
                <span><strong>Permitir tools</strong><small>O runtime só expõe tools aprovadas na versão do agente.</small></span>
                <button appSwitch type="button" [ngpSwitchChecked]="node.config['allowTools'] === true" [ngpSwitchDisabled]="readOnly()" (ngpSwitchCheckedChange)="updateAllowTools($event)"><span appSwitchThumb></span></button>
              </div>
            }
            <label>
              <span appUiLabel>Contrato de saída</span>
              <textarea appTextarea rows="5" class="code-field" [disabled]="readOnly()" [value]="configText(node, 'outputSchema')" (input)="updateJsonConfig('outputSchema', $event)"></textarea>
              @if (jsonError('outputSchema'); as error) { <span class="field-error">{{ error }}</span> }
            </label>
          } @else if (node.type === 'condition') {
            <label><span appUiLabel>Node de origem</span><input appInput [disabled]="readOnly()" [value]="configText(node, 'sourceNodeId')" (input)="updateConfig('sourceNodeId', $event)" /></label>
            <label><span appUiLabel>Caminho do valor</span><input appInput [disabled]="readOnly()" placeholder="content" [value]="configText(node, 'path')" (input)="updateConfig('path', $event)" /></label>
            <label>
              <span appUiLabel>Operador</span>
              <select appNativeSelect [disabled]="readOnly()" [value]="configText(node, 'operator')" (change)="updateConfig('operator', $event)">
                <option value="exists">Existe</option><option value="equals">É igual</option><option value="not_equals">É diferente</option><option value="contains">Contém</option><option value="greater_than">Maior que</option><option value="less_than">Menor que</option>
              </select>
            </label>
            <label><span appUiLabel>Valor de comparação</span><input appInput [disabled]="readOnly()" [value]="configText(node, 'value')" (input)="updateConfig('value', $event)" /></label>
          } @else if (node.type === 'knowledge') {
            <label><span appUiLabel>Template da consulta</span><textarea appTextarea rows="4" [disabled]="readOnly()" [value]="configText(node, 'queryTemplate')" (input)="updateConfig('queryTemplate', $event)"></textarea></label>
            <label><span appUiLabel>Máximo de resultados</span><input appInput type="number" min="1" max="20" [disabled]="readOnly()" [value]="configText(node, 'topK')" (input)="updateNumberConfig('topK', $event)" /></label>
            <label><span appUiLabel>Mapeamento de saída</span><textarea appTextarea rows="5" class="code-field" [disabled]="readOnly()" [value]="configText(node, 'outputMapping')" (input)="updateJsonConfig('outputMapping', $event)"></textarea>@if (jsonError('outputMapping'); as error) { <span class="field-error">{{ error }}</span> }</label>
          } @else if (node.type === 'tool') {
            <label><span appUiLabel>Chave da tool</span><input appInput [disabled]="readOnly()" placeholder="crm.contacts.search" [value]="configText(node, 'toolKey')" (input)="updateConfig('toolKey', $event)" /></label>
            <label><span appUiLabel>Mapeamento de entrada</span><textarea appTextarea rows="6" class="code-field" [disabled]="readOnly()" [value]="configText(node, 'inputMapping')" (input)="updateJsonConfig('inputMapping', $event)"></textarea>@if (jsonError('inputMapping'); as error) { <span class="field-error">{{ error }}</span> }</label>
            <label><span appUiLabel>Mapeamento de saída</span><textarea appTextarea rows="6" class="code-field" [disabled]="readOnly()" [value]="configText(node, 'outputMapping')" (input)="updateJsonConfig('outputMapping', $event)"></textarea>@if (jsonError('outputMapping'); as error) { <span class="field-error">{{ error }}</span> }</label>
          } @else if (node.type === 'handoff') {
            <label><span appUiLabel>Destino</span><input appInput [disabled]="readOnly()" placeholder="Equipe ou pessoa" [value]="configText(node, 'targetId')" (input)="updateConfig('targetId', $event)" /></label>
            <label><span appUiLabel>Regra de encaminhamento</span><textarea appTextarea rows="5" [disabled]="readOnly()" [value]="configText(node, 'rule')" (input)="updateConfig('rule', $event)"></textarea></label>
          } @else {
            <label><span appUiLabel>Instrução complementar</span><textarea appTextarea rows="6" [disabled]="readOnly()" [value]="configText(node, 'promptExtension')" (input)="updateConfig('promptExtension', $event)"></textarea></label>
          }
        </div>

        @if (!node.protected && !readOnly()) {
          <footer appUiDrawerFooter>
            <button appButton variant="danger" size="sm" type="button" (click)="deleteSelectedNode()"><ng-icon name="heroTrash" size="15" /> Remover node</button>
          </footer>
        }
      </aside>
    }

    @if (libraryOpen()) {
      <div appUiDrawerOverlay [side]="'left'" tabindex="-1" (click)="libraryOpen.set(false)" (keydown.escape)="libraryOpen.set(false)">
        <aside appUiDrawer [side]="'left'" class="library-drawer" role="dialog" aria-modal="true" aria-label="Biblioteca de nodes" tabindex="-1" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          <header appUiDrawerHeader>
            <div><strong>Adicionar node</strong><p>Insira após o node selecionado.</p></div>
            <button appUiIconButton variant="ghost" size="sm" type="button" aria-label="Fechar biblioteca" (click)="libraryOpen.set(false)"><ng-icon name="heroXMark" size="17" /></button>
          </header>
          <div appUiDrawerBody class="library-list">
            @for (template of nodeTemplates; track template.type) {
              <button type="button" (click)="addNode(template)">
                <span><ng-icon [name]="template.icon" size="18" /></span>
                <span><strong>{{ template.label }}</strong><small>{{ template.description }}</small></span>
                <ng-icon name="heroPlus" size="15" />
              </button>
            }
          </div>
          <footer appUiDrawerFooter><span appUiHint>Nodes de segurança estruturais permanecem protegidos no fluxo.</span></footer>
        </aside>
      </div>
    }

    @if (testOpen()) {
      <div appUiDrawerOverlay tabindex="-1" (click)="testOpen.set(false)" (keydown.escape)="testOpen.set(false)">
        <aside appUiDrawer class="test-drawer" role="dialog" aria-modal="true" aria-label="Smoke test" tabindex="-1" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          <header appUiDrawerHeader>
            <div><strong>Smoke test</strong><p>Tools mutáveis e envios ficam bloqueados.</p></div>
            <button appUiIconButton variant="ghost" size="sm" type="button" aria-label="Fechar teste" (click)="testOpen.set(false)"><ng-icon name="heroXMark" size="17" /></button>
          </header>
          <div appUiDrawerBody class="test-body">
            <label><span appUiLabel>Mensagem de entrada</span><textarea appTextarea rows="6" [value]="testMessage()" (input)="testMessage.set($any($event.target).value)"></textarea></label>
            @if (testOutput()) {
              <section class="test-result"><span>Saída</span><p>{{ testOutput() }}</p></section>
            }
          </div>
          <footer appUiDrawerFooter>
            <button appButton variant="secondary" type="button" (click)="testOpen.set(false)">Fechar</button>
            <button appButton variant="primary" type="button" [disabled]="busyAction() !== null" (click)="runTest()">
              @if (busyAction() === 'test') { <app-ui-spinner [size]="15" [stroke]="2" /> }
              Executar teste
            </button>
          </footer>
        </aside>
      </div>
    }
  }
</main>
